import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'educare-bio-info-dialog',
  standalone: true,
  templateUrl: './bio-info-dialog.component.html',
  styleUrl: './bio-info-dialog.component.scss',
  imports: [CommonModule, MatDialogContent, MatDialogTitle, MatButtonModule, MatIconModule, TranslateModule]
})
export class BioInfoDialogComponent {
  public readonly dialogRef = inject(MatDialogRef<BioInfoDialogComponent>);
  public readonly data = inject<{ bio: string; speakerName: string }>(MAT_DIALOG_DATA);

  onClose(): void {
    this.dialogRef.close();
  }
}
